import { combineReducers } from 'redux';

import TaskDetails from './TaskDetails';
import TaskItem from './TaskItem';
import TaskReassign from './TaskReassign';
import TaskReopen from './TaskReopen';
import RunAbort from './RunAbort';

const childReducers = {
  TaskDetails,
  TaskItem,
  TaskReassign,
  TaskReopen,
  RunAbort
};

const combinedReducers = combineReducers(childReducers);

export default function Tasks(state, action) {
  if (state && state.combined) {
    delete state.combined;
  }
  const childrenState = combinedReducers(state, action);

  const combined = {};

  Object.keys(childReducers).forEach(childReducer => {
    const childState = childrenState[childReducer] || {};
    combined.loading = combined.loading || childState.loading;
    combined.saving = combined.saving || childState.saving;
  });

  return {
    ...childrenState,
    combined
  };
}



// WEBPACK FOOTER //
// ./js/reducers/page/tasks/index.js